export type ErpProvider = "simi" | "nuwwe";

export type ErpProviderOption = {
  id: ErpProvider;
  name: string;
};

export const ERP_PROVIDERS: ErpProviderOption[] = [
  { id: "simi", name: "SIMI" },
  { id: "nuwwe", name: "Nuwwe" },
];

export type SimiFormData = {
  usernameAdmin: string;
  passwordAdmin: string;
};

export type NuwweFormData = {
  merchantUrl: string;
  token: string;
  empresa: string;
};
